module.exports = __webpack_public_path__ + "img/26400.7d630186.jpg";